module.exports = __webpack_public_path__ + "static/img/bak02.7c6a075.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/bak02.jpeg
// module id = sQ0C
// module chunks = 1